import find from 'lodash/find';
import get from 'lodash/get';
import without from 'lodash/without';
import sortBy from 'lodash/sortBy';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import isUndefined from 'lodash/isUndefined';
import map from 'lodash/map';

import StoresCollection from './collection';
import StoreModel from './model';

export const state = {
  storesCollection: new StoresCollection(),
  currentStore: {},
  originalCurrentStore: {},
  clientTags: [],
  isDirty: false,
};

export const mutations = {
  setStores(state, response) {
    state.storesCollection.stores = [...state.storesCollection.stores, ...response.data._embedded.items];
    state.storesCollection.initialized = true;
    state.storesCollection.total = response.data.total_results;

    if (response.data._embedded.items.length === state.storesCollection.limit) {
      state.storesCollection.page++;
      state.storesCollection.canLoad = true;
    } else {
      state.storesCollection.canLoad = false;
    }
  },

  sortStores(state, sortColumn) {
    state.storesCollection.sortDirection = state.storesCollection.sortColumn === sortColumn && !state.storesCollection.sortDirection ? 1 : 0;
    state.storesCollection.sortColumn = sortColumn;
  },

  resetStores(state) {
    state.storesCollection.stores = [];
    state.storesCollection.page = 0;
    state.storesCollection.canLoad = true;
    state.storesCollection.initialized = false;
    state.storesCollection.total = 0;
  },

  setStore(state, storeData) {
    state.currentStore = storeData;

    if (!state.currentStore.domain_id) {
      state.currentStore.domain_id = 'VS';
    }

    state.currentStore.campaigns = sortBy(state.currentStore.campaigns, 'priority');
    state.currentStore.tags = map(state.currentStore.tags, tag => tag.id);

    state.isDirty = false;
  },

  updateCurrentStore(state, { prop, value }) {
    state.currentStore[prop] = value;
    state.isDirty = !isEqual(state.currentStore, state.originalCurrentStore);
  },

  setOriginalCurrentStore(state) {
    state.originalCurrentStore = cloneDeep(state.currentStore);
    state.isDirty = false;
  },

  updateCurrentStoreCampaignsPriority(state, campaigns) {
    for (let i = 0; i < campaigns.length; i++) {
      if (campaigns[i]) campaigns[i].priority = i;
    }

    state.currentStore.campaigns = campaigns;

    state.isDirty = !isEqual(state.currentStore, state.originalCurrentStore);
  },

  resetCurrentStore(state) {
    state.currentStore = {};
    state.originalCurrentStore = {};
    state.isDirty = false;
  },

  createStore(state) {
    state.currentStore = new StoreModel();
    state.isDirty = false;
  },

  disableStore(state, store) {
    state.storesCollection.stores.splice(findIndex(state.storesCollection.stores, s => s.id === store.id), 1);
  },

  toggleCurrentStoreCampaign(state, campaign) {
    let campaignId,
      existingCampaign;

    if (get(campaign, 'campaign_id')) {
      campaignId = campaign.campaign_id;
    } else {
      campaignId = campaign.id;
    }

    if (!isUndefined(campaign.item_count)) {
      campaign.current_order_count = campaign.item_count;
    }

    existingCampaign = find(state.currentStore.campaigns, currentCampaign => {
      if (get(currentCampaign, 'campaign_id')) {
        return campaignId === currentCampaign.campaign_id;
      } else {
        return campaignId === currentCampaign.id;
      }
    });

    if (existingCampaign) {
      state.currentStore.campaigns = without(state.currentStore.campaigns, existingCampaign);
    } else {
      state.currentStore.campaigns = [...state.currentStore.campaigns, campaign];
    }

    mutations.updateCurrentStoreCampaignsPriority(state, state.currentStore.campaigns);

    state.isDirty = !isEqual(state.currentStore, state.originalCurrentStore);
  },

  setCurrentStoreCampaigns(state, campaigns) {
    state.currentStore.campaigns = campaigns;
  },

  setClientTags(state, tags) {
    state.clientTags = tags;
  },

  storeIsDirty(state, isDirty) {
    state.isDirty = isDirty;
  },

  toggleActivateStore(state, { store, activated }) {
    store.status = activated ? 'ONLINE' : 'OFFLINE';
  },

  setStoresQuery(state, titleQuery) {
    state.storesCollection.query = titleQuery;
  },
};